var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.396 49.0625C101.396 61.7075 91.145 71.9584 78.5 71.9584C65.8549 71.9584 55.6041 61.7075 55.6041 49.0625C55.6041 36.4175 65.8549 26.1667 78.5 26.1667C91.145 26.1667 101.396 36.4175 101.396 49.0625Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M127.562 49.0625C127.562 58.0946 120.24 65.4166 111.208 65.4166C102.176 65.4166 94.8541 58.0946 94.8541 49.0625C94.8541 40.0303 102.176 32.7083 111.208 32.7083C120.24 32.7083 127.562 40.0303 127.562 49.0625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.4375 49.0625C29.4375 58.0946 36.7596 65.4166 45.7917 65.4166C54.8239 65.4166 62.1459 58.0946 62.1459 49.0625C62.1459 40.0303 54.8239 32.7083 45.7917 32.7083C36.7596 32.7083 29.4375 40.0303 29.4375 49.0625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.75 107.938C117.75 120.583 100.177 130.833 78.5 130.833C56.8228 130.833 39.25 120.583 39.25 107.938C39.25 95.2925 56.8228 85.0417 78.5 85.0417C100.177 85.0417 117.75 95.2925 117.75 107.938Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M143.917 107.937C143.917 116.97 132.201 124.292 117.75 124.292C103.299 124.292 91.5834 116.97 91.5834 107.937C91.5834 98.9053 103.299 91.5833 117.75 91.5833C132.201 91.5833 143.917 98.9053 143.917 107.937Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.0833 107.937C13.0833 116.97 24.7985 124.292 39.25 124.292C53.7014 124.292 65.4166 116.97 65.4166 107.937C65.4166 98.9053 53.7014 91.5833 39.25 91.5833C24.7985 91.5833 13.0833 98.9053 13.0833 107.937Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuReferral);
export default __webpack_public_path__ + "static/media/menu-referral.efd0ff5de42e88e20cfbe07dbd95906a.svg";
export { ForwardRef as ReactComponent };